import { render, staticRenderFns } from "./ExamStructureProperties.vue?vue&type=template&id=7afab9be&"
import script from "./ExamStructureProperties.vue?vue&type=script&lang=js&"
export * from "./ExamStructureProperties.vue?vue&type=script&lang=js&"
import style0 from "./ExamStructureProperties.vue?vue&type=style&index=0&id=7afab9be&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports